@if (canShow) {
  <button
    mat-menu-item
    (click)="onExport()"
    [disabled]="selectedProducts.length === 0"
    >
    <mat-icon>archive</mat-icon>
    <span>Export Shoot Assets</span>
  </button>
}
